interface Introspectable {
  $options?: { __file?: string };
  name?: string;
  constructor?: { name?: string };
}

function randomSuffix(): string {
  return Math.random().toString(36).slice(2, 6);
}

function resolveWindowKey(
  obj: Introspectable | null,
  explicit?: string
): string {
  if (explicit) return `__${explicit}`;

  if (obj?.$options) {
    const filename = obj.$options.__file?.split('/').pop()?.replace('.vue', '');
    return filename ? `__${filename}` : `__Vue_${randomSuffix()}`;
  }

  const className = obj?.name ?? obj?.constructor?.name;
  if (className && className !== 'Object') return `__${className}`;

  return `__Object_${randomSuffix()}`;
}

export default function exposeToGlobalScope(
  internalThis: unknown,
  optionalName?: string
): void {
  const windowKey = resolveWindowKey(
    internalThis as Introspectable | null,
    optionalName
  );
  (window as unknown as Record<string, unknown>)[windowKey] = internalThis;
}
